import type React from "react"

interface GradeBallProps {
  grade: string | number
}

export const GradeBall: React.FC<GradeBallProps> = ({ grade }) => {
  return (
    <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-800 flex items-center justify-center text-sm font-semibold">
      {grade}
    </div>
  )
}
